import {TotalsData} from "../../../types";
import {formatMoney} from "../../../../dashboard/utils";
import {ValueCard} from "./styles";

export const Totals: React.FC<{data: TotalsData}> = ({data}) => {
  const formatTotal = (value: number): string => {
    if (isNaN(value)) value = 0;
    return formatMoney(value);
  }

  return (
    <>
      <ValueCard>
        <div>
          <p style={{fontWeight: 'bolder'}}>Valor Total:</p>
          <p>{formatTotal(data.totalValue)}</p>
        </div>

        <div>
          <p style={{fontWeight: 'bolder'}}>Valor Debitado:</p>
          <p>{formatTotal(data.totalPayed)}</p>
        </div>

        <div>
          <p style={{fontWeight: 'bolder'}}>Valor a Debitar:</p>
          <p>{formatTotal(data.totalPending)}</p>
        </div>

        <div>
          <p style={{fontWeight: 'bolder'}}>Qntd. POS Isentas:</p>
          <p>{data.totalExemptPos}</p>
        </div>

        <div>
          <p style={{fontWeight: 'bolder'}}>Valor Isentado:</p>
          <p>{formatTotal(data.totalExemptValue)}</p>
        </div>
      </ValueCard>
    </>
  )
}
